<template>
    <div>
        <double-bar-chart 
            :headerTitle="total_welding_dia_inch_per_period_vs_target_progress_per_period.headerTitle" 
            :headingSize="total_welding_dia_inch_per_period_vs_target_progress_per_period.headingSize"
            :chartSeries="total_welding_dia_inch_per_period_vs_target_progress_per_period.chartSeries"
            :chartxAxis="total_welding_dia_inch_per_period_vs_target_progress_per_period.chartxAxis"
            :chartLegend="total_welding_dia_inch_per_period_vs_target_progress_per_period.chartLegend"
            :chartLoaded="total_welding_dia_inch_per_period_vs_target_progress_per_period.chartLoaded"
        >
        </double-bar-chart>

        <double-bar-chart 
            :headerTitle="total_welding_dia_inch_prefabrication_per_period_vs_target_progress_prefabrication_per_period.headerTitle" 
            :headingSize="total_welding_dia_inch_prefabrication_per_period_vs_target_progress_prefabrication_per_period.headingSize"
            :chartSeries="total_welding_dia_inch_prefabrication_per_period_vs_target_progress_prefabrication_per_period.chartSeries"
            :chartxAxis="total_welding_dia_inch_prefabrication_per_period_vs_target_progress_prefabrication_per_period.chartxAxis"
            :chartLegend="total_welding_dia_inch_prefabrication_per_period_vs_target_progress_prefabrication_per_period.chartLegend"
            :chartLoaded="total_welding_dia_inch_prefabrication_per_period_vs_target_progress_prefabrication_per_period.chartLoaded"
            :cardHeaderColor="'bg-info-card'"
        >
        </double-bar-chart>

        <double-bar-chart 
            :headerTitle="total_welding_dia_inch_erection_per_period_vs_target_progress_erection_per_period.headerTitle" 
            :headingSize="total_welding_dia_inch_erection_per_period_vs_target_progress_erection_per_period.headingSize"
            :chartSeries="total_welding_dia_inch_erection_per_period_vs_target_progress_erection_per_period.chartSeries"
            :chartxAxis="total_welding_dia_inch_erection_per_period_vs_target_progress_erection_per_period.chartxAxis"
            :chartLegend="total_welding_dia_inch_erection_per_period_vs_target_progress_erection_per_period.chartLegend"
            :chartLoaded="total_welding_dia_inch_erection_per_period_vs_target_progress_erection_per_period.chartLoaded"
            :cardHeaderColor="'bg-secondary-card'"
        >
        </double-bar-chart>
    </div>
</template>

<script>
import Vue from 'vue';
import DoubleBarChart from '@/components/pages/project/percent_progress/common/charts/double_bar_chart.vue';

export default {
    name: 'periodical_analysis_charts_welding',
    components: {
        DoubleBarChart,
    },
    props: {
        rowData: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            //Total Welding DIA Inch per Period vs Target Progress per Period
            total_welding_dia_inch_per_period_vs_target_progress_per_period: {
                headerTitle: Vue.i18n.translate('general.projects.progress.total_welding_dia_inch_per_period_vs_target_progress_per_period_chart.title'),
                headingSize: 'h4',
                chartSeries: [
                    {
                        name: Vue.i18n.translate('table.total_dia_inch_progress_per_period'),
                        type: 'bar',
                        data: []
                    },
                    {
                        name: Vue.i18n.translate('table.total_dia_inch_progress_week'),
                        type: 'bar',
                        data: []
                    }
                ],
                chartSeriesAvailable: [
                    'total_dia_inch_progress_per_period',
                    'total_dia_inch_progress_week'
                ],
                chartxAxis: [],
                chartLegend: [
                    {
                        name: Vue.i18n.translate('table.total_dia_inch_progress_per_period'),
                    },
                    {
                        name: Vue.i18n.translate('table.total_dia_inch_progress_week'),
                    },
                ],
                chartLoaded: false,
            },

            //Total Welding DIA Inch Prefabrication per Period vs Target Progress Prefabrication per Period
            total_welding_dia_inch_prefabrication_per_period_vs_target_progress_prefabrication_per_period: {
                headerTitle: Vue.i18n.translate('general.projects.progress.total_welding_dia_inch_prefabrication_per_period_vs_target_progress_prefabrication_per_period.title'),
                headingSize: 'h4',
                chartSeries: [
                    {
                        name: Vue.i18n.translate('table.total_dia_inch_prefabrication_progress_per_period'),
                        type: 'bar',
                        data: []
                    },
                    {
                        name: Vue.i18n.translate('table.total_dia_inch_prefabrication_progress_week'),
                        type: 'bar',
                        data: []
                    }
                ],
                chartSeriesAvailable: [
                    'total_dia_inch_prefabrication_progress_per_period',
                    'total_dia_inch_prefabrication_progress_week'
                ],
                chartxAxis: [],
                chartLegend: [
                    {
                        name: Vue.i18n.translate('table.total_dia_inch_prefabrication_progress_per_period'),
                    },
                    {
                        name: Vue.i18n.translate('table.total_dia_inch_prefabrication_progress_week'),
                    },
                ],
                chartLoaded: false,
            },

            //Total Welding DIA Inch Erection per Period vs Target Progress Erection per Period
            total_welding_dia_inch_erection_per_period_vs_target_progress_erection_per_period: {
                headerTitle: Vue.i18n.translate('general.projects.progress.total_welding_dia_inch_erection_per_period_vs_target_progress_erection_per_period.title'),
                headingSize: 'h4',
                chartSeries: [
                    {
                        name: Vue.i18n.translate('table.total_dia_inch_erection_progress_per_period'),
                        type: 'bar',
                        data: []
                    },
                    {
                        name: Vue.i18n.translate('table.total_dia_inch_erection_progress_week'),
                        type: 'bar',
                        data: []
                    }
                ],
                chartSeriesAvailable: [
                    'total_dia_inch_erection_progress_per_period',
                    'total_dia_inch_erection_progress_week'
                ],
                chartxAxis: [],
                chartLegend: [
                    {
                        name: Vue.i18n.translate('table.total_dia_inch_erection_progress_per_period'),
                    },
                    {
                        name: Vue.i18n.translate('table.total_dia_inch_erection_progress_week'),
                    },
                ],
                chartLoaded: false,
            },
        }
    },
    mounted () {
        this.onLoadChart1();
        this.onLoadChart2();
        this.onLoadChart3();
    },
    methods: {
        onLoadChart1 () {
            this.rowData.forEach(field => {
                this.total_welding_dia_inch_per_period_vs_target_progress_per_period.chartxAxis.push(field.step_calendar);
                var that = this;
                
                Object.keys(field).forEach(function(key) {
                    if (that.total_welding_dia_inch_per_period_vs_target_progress_per_period.chartSeriesAvailable[0] === key) {
                        that.total_welding_dia_inch_per_period_vs_target_progress_per_period.chartSeries[0].data.push(field[key]);
                    }
                    
                    if (that.total_welding_dia_inch_per_period_vs_target_progress_per_period.chartSeriesAvailable[1] === key) {
                        that.total_welding_dia_inch_per_period_vs_target_progress_per_period.chartSeries[1].data.push(field[key]);
                    }
                });
            });

            this.total_welding_dia_inch_per_period_vs_target_progress_per_period.chartLoaded = (this.rowData.length > 0);
        },
        onLoadChart2 () {
            this.rowData.forEach(field => {
                this.total_welding_dia_inch_prefabrication_per_period_vs_target_progress_prefabrication_per_period.chartxAxis.push(field.step_calendar);
                var that = this;
                
                Object.keys(field).forEach(function(key) {
                    if (that.total_welding_dia_inch_prefabrication_per_period_vs_target_progress_prefabrication_per_period.chartSeriesAvailable[0] === key) {
                        that.total_welding_dia_inch_prefabrication_per_period_vs_target_progress_prefabrication_per_period.chartSeries[0].data.push(field[key]);
                    }
                    
                    if (that.total_welding_dia_inch_prefabrication_per_period_vs_target_progress_prefabrication_per_period.chartSeriesAvailable[1] === key) {
                        that.total_welding_dia_inch_prefabrication_per_period_vs_target_progress_prefabrication_per_period.chartSeries[1].data.push(field[key]);
                    }
                });
            });

            this.total_welding_dia_inch_prefabrication_per_period_vs_target_progress_prefabrication_per_period.chartLoaded = (this.rowData.length > 0);
        },
        onLoadChart3 () {
            this.rowData.forEach(field => {
                this.total_welding_dia_inch_erection_per_period_vs_target_progress_erection_per_period.chartxAxis.push(field.step_calendar);
                var that = this;
                
                Object.keys(field).forEach(function(key) {
                    if (that.total_welding_dia_inch_erection_per_period_vs_target_progress_erection_per_period.chartSeriesAvailable[0] === key) {
                        that.total_welding_dia_inch_erection_per_period_vs_target_progress_erection_per_period.chartSeries[0].data.push(field[key]);
                    }
                    
                    if (that.total_welding_dia_inch_erection_per_period_vs_target_progress_erection_per_period.chartSeriesAvailable[1] === key) {
                        that.total_welding_dia_inch_erection_per_period_vs_target_progress_erection_per_period.chartSeries[1].data.push(field[key]);
                    }
                });
            });

            this.total_welding_dia_inch_erection_per_period_vs_target_progress_erection_per_period.chartLoaded = (this.rowData.length > 0);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/percent_progress/welding/periodical_analysis/periodical_analysis_charts_welding.vue